import { createFileRoute } from "@tanstack/react-router";
import { BillingManagement } from "@/features/billing/billing-management/BillingManagement";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_dashboard/billing-management/")({
  component: BillingManagementPage,
  validateSearch: () => ({}), // 空のスキーマを明示的に定義
});

function BillingManagementPage() {
  usePageTitle("課金権限管理");

  return <BillingManagement />;
}